export function reduce() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
} //# sourceMappingURL=stateId.js.map